export default "__VITE_ASSET__DdnXLRB8__"